<template>
    <el-dialog title="Form Region" :visible="visible" width="40%" :before-close="dismis">
        <el-form :model="form">
            <div class="row">
                <div class="col-12">
                    <el-form-item label="Code">
                        <el-input v-model="form.code" :disabled="type=='edit'" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Name">
                        <el-input v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Acronym">
                        <el-input v-model="form.acronym" autocomplete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dismis">Cancel</el-button>
            <el-button v-if="type=='add'" type="primary" @click="saveRegion()" :loading="loading">Confirm</el-button>
            <el-button v-else type="primary" @click="updateRegion()" :loading="loading">Confirm</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import regions from '@/api/regions'
    export default {
        props: ['visible', 'form', 'type'],
        data() {
            return {
                loading: false
            }
        },
        mounted () {
        },
        methods: {
            dismis() {
                this.$parent.dismisFormAdd();
            },
            saveRegion(){
                var params = {
                    code: this.form.code,
                    name: this.form.name,
                    acronym: this.form.acronym
                }
                this.loading = true
                var self = this
                regions.add(params)
                .then(function (response) {
                    self.loading = false
                    self.$parent.dialogFormAddVisible = false
                    self.$parent.fetch()
                    // console.log(response);
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading = false
                    // console.log(error);
                    self.$message({
                        type: 'error',
                        message: error.response.data.message
                    });
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
            updateRegion(){
                var params = {
                    name: this.form.name,
                    acronym: this.form.acronym
                }
                this.loading = true
                var self = this
                regions.update(this.form.code, params)
                .then(function (response) {
                    self.loading = false
                    self.$parent.dialogFormAddVisible = false
                    self.$parent.fetch()
                    // console.log(response);
                    self.$message({
                        type: 'success',
                        message: response.data.message
                    });
                })
                .catch(function (error) {
                    self.loading = false
                    // console.log(error);
                    self.$message({
                        type: 'error',
                        message: error.response.data.message
                    });
                    if(error.response.status == 403){
                        self.logout()
                    }
                })
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>